export enum SpecificationFormEnum {
  PRODUCT_FORM = 'productForm',
  PUMPING_FORM = 'pumpingForm',
  ADDRESS_FORM = 'addressForm',
}
